import { axios } from '@/utils/http'
import { TaiwanEnroll } from '@/models/enroll/taiwanStudent'
import { TableResponse, Params } from '@/components/table'
import { paramsApdapter } from '@/utils/apdapter'

const API_URL = `student/TaiwanEnroll`

/**
 * 获取台湾学生申请列表
 */
export async function getList(): Promise<TableResponse<TaiwanEnroll>>

/**
 * 获取台湾学生申请列表
 * @param limit
 * @param offset
 */
export async function getList(
  limit: number,
  offset: number
): Promise<TableResponse<TaiwanEnroll>>

/**
 * 获取台湾学生申请列表
 * @param params Params of Table Component
 */
export async function getList(
  params: Params
): Promise<TableResponse<TaiwanEnroll>>

export async function getList(param1?: number | Params, param2?: number) {
  return typeof param1 === 'object'
    ? getListByTableParams(param1)
    : getListByLimitAndOffset(param1, param2)
}

async function getListByLimitAndOffset(
  limit: number = 9999,
  offset: number = 0
) {
  const url = `${API_URL}?limit=${limit}&offset=${offset}`
  const { data } = await axios.get(url)
  return data as TableResponse<TaiwanEnroll>
}

async function getListByTableParams(params: Params) {
  const { data } = await axios.get(API_URL, {
    params: paramsApdapter(params)
  })
  return data as TableResponse<TaiwanEnroll>
}

export async function get(id: string) {
  const { data } = await axios.get(`${API_URL}/${id}`)
  return data as TaiwanEnroll
}
